import React from "react";
import styled from "@emotion/styled";
import ParkkiTheme from "themes/ParkkiTheme";

const Container = styled.div`
  display: flex;
  flex: 1;
  height: 100%;
  overflow-y: hidden;
`;

const LeftContainer = styled.div`
  background-color: ${ParkkiTheme.colors.lightGrey};
  flex: 1;
  max-width: ${(props: { fullscreen?: boolean; fullHalf?: boolean }) =>
    props.fullscreen ? "100%" : props.fullHalf ? "50%" : "706px"};
  overflow-y: auto;
  height: 100%;
`;

const RightContainer = styled.div`
  flex: 1;
`;

type Props = {
  containerStyle: object;
  leftContainerStyle: object;
  rightContainerStyle: object;
  fullscreen?: boolean;
  leftComponent: React.ReactNode;
  rightComponent: React.ReactNode;
  fullHalf?: boolean;
};

function HalfLayout({
  leftComponent,
  rightComponent,
  fullscreen,
  fullHalf,
}: Props): JSX.Element {
  return (
    <Container>
      <LeftContainer fullHalf={fullHalf} fullscreen={fullscreen}>
        {leftComponent}
      </LeftContainer>

      {!fullscreen ? <RightContainer>{rightComponent}</RightContainer> : null}
    </Container>
  );
}

export default HalfLayout;
